import {FooterType} from "../app/FooterType";
import {PledgerAction} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {Reducer} from "redux";
import {
    SouscriptionStepProgress,
    SouscriptionStepStatus
} from "../../services/ws/SouscriptionSuivi/dto/SouscriptionProgressJSON";
import {CreditFeaturesJSON} from "../../services/ws/SouscriptionSuivi/dto/CreditFeaturesJSON";
import {SouscriptionSuiviActions} from "./SouscriptionSuiviActions";
import {souscriptionSuiviWServiceActions} from "../../services/ws/SouscriptionSuivi/souscriptionSuiviWServiceActions";

const footerType = (state = FooterType.NONE, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.NONE;
    }
};

const souscriptionId = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case SouscriptionSuiviActions.SOUSCRIPTION_SUIVI_PAGE_LOADED_ACTION.type:
            return action.payload.souscriptionId;
        default:
            return state;
    }
};

const pageLoaded = (state = true, action : PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_FAILED_ACTION.type:
            return true;

        default:
            return state;
    }
};

const errorLoading = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
            return false;

        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_FAILED_ACTION.type:
            return true;

        default:
            return state;
    }
};

const navigationMenuEnabled = (state = true, action : PledgerAction) => {
    switch (action.type) {
        default:
            return true;
    }
};

const dataLoaded = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
            return true;

        default:
            return state;
    }
};

const hasCoBorrower = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
            return action.payload.data.souscriptionProgress.hasCoborrower;
        default:
            return state;
    }
};

const currentStepDescription = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
            return action.payload.data.souscriptionProgress.currentStepDescription;

        default:
            return state;
    }
};

const steps = (state: SouscriptionStepProgress[] = [], action: PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
            return action.payload.data.souscriptionProgress.steps;

        default:
            return state;
    }
};

const isPending = (state: boolean = false, action: PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type: {
            const steps: SouscriptionStepProgress[] = action.payload.data.souscriptionProgress.steps;
            return undefined !== steps.find(step => step.stepStatus === SouscriptionStepStatus.CURRENT || step.stepStatus === SouscriptionStepStatus.PENDING);
        }

        default:
            return state;
    }
};


const creditFeatures = (state = {}, action : PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
            return action.payload.data.creditFeatures;

        default:
            return state;
    }
};

const documentationURL = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
            return action.payload.data.documentationURL ?? '';

        default:
            return state;
    }
};

const canResentSouscriptionEmail = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
            return action.payload.data.canResentSouscriptionEmail ?? false;

        default:
            return state;
    }
};

const loanContractNumber = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
            return action.payload.data.loanContractNumber ?? '';

        default:
            return state;
    }
};

const paymentEstimatedDate = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
            return action.payload.data.souscriptionProgress.paymentEstimatedDate;

        default:
            return state;
    }
};

const loanEndEstimatedDate = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_SUCCEEDED_ACTION.type:
            return action.payload.data.souscriptionProgress.loanEndEstimatedDate;

        default:
            return state;
    }
};

export interface SouscriptionSuiviPageComponentState extends PledgerPageComponentState {
    pageLoaded: boolean;
    dataLoaded: boolean;
    errorLoading: boolean;
    souscriptionId:string;
    hasCoBorrower: boolean;
    steps: SouscriptionStepProgress[];
    creditFeatures: CreditFeaturesJSON;
    paymentEstimatedDate: string;
    loanEndEstimatedDate: string;
    currentStepDescription: string;
    isPending:boolean;
    documentationURL : string;
    loanContractNumber : string;
    canResentSouscriptionEmail:boolean;
}

export const souscriptionSuivi: Reducer = (state={}, action)=>{
    return{
        footerType: footerType(state.footerType, action),
        pageLoaded: pageLoaded(state.pageLoaded, action),
        errorLoading:errorLoading(state.errorLoading,action),
        navigationMenuEnabled: navigationMenuEnabled(state.navigationMenuEnabled, action),
        souscriptionId:souscriptionId(state.souscriptionId,action),
        dataLoaded:dataLoaded(state.dataLoaded, action),
        hasCoBorrower:hasCoBorrower(state.hasCoBorrower, action),
        steps:steps(state.steps, action),
        creditFeatures:creditFeatures(state.creditFeatures, action),
        paymentEstimatedDate:paymentEstimatedDate(state.paymentEstimatedDate, action),
        loanEndEstimatedDate:loanEndEstimatedDate(state.loanEndEstimatedDate, action),
        currentStepDescription:currentStepDescription(state.currentStepDescription,action),
        isPending:isPending(state.isPending,action),
        documentationURL:documentationURL(state.documentationURL,action),
        loanContractNumber:loanContractNumber(state.loanContractNumber,action),
        canResentSouscriptionEmail:canResentSouscriptionEmail(state.canResentSouscriptionEmail,action)
    }
}
